import { createSlice } from "@reduxjs/toolkit";

import axios from "../../utils/axios";
import utils from "../../utils/utils";
import { dispatch } from "../index";

const navigateTo = "/equipment-type";

const initialState = {
  equipmentType: [],
  equipmentTypeObject: [],
  error: null,
  totalPages: 1,
  loading: false,
  limit: 10,
  currentPage: 1,
};

// Reducer
const slice = createSlice({
  name: "equipmentType",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    startLoading(state, action) {
      state.loading = true;
    },
    stopLoading(state, action) {
      state.loading = false;
    },

    // GET USERS STYLE 1
    getEquipmentTypeSuccess(state, action) {
      const data = action.payload.data;
      state.equipmentType = utils.sortAlphatically(data, "name");
      state.equipmentTypeObject = utils.getUniqueObject(data, "id");
      const totalEquipments = action.payload.totalItems;
      let pages = Math.floor(totalEquipments / state.limit);
      const remainder = totalEquipments % state.limit;
      if (remainder !== 0) {
        pages += 1;
      }
      state.totalPages = pages;
      state.loading = false;
    },
    addEquipmentTypeSuccess(state, action) {
      state.loading = false;
    },
    editEquipmentTypeSuccess(state, action) {
      state.loading = false;
    },
    deleteEquipmentTypeSuccess(state, action) {
      state.loading = false;
      state.equipmentType = state.equipmentType.filter(
        (item) => item.id !== action.payload.id
      );
    },
    setCurrentPage(state, action) {
      console.log(action.payload);
      state.currentPage = action.payload;
    },
  },
});

export default slice.reducer;

// Actions
export function startLoading() {
  return async () => {
    dispatch(slice.actions.startLoading());
  };
}

export function stopLoading() {
  return async () => {
    dispatch(slice.actions.stopLoading());
  };
}

export function getEquipmentType() {
  return async () => {
    try {
      const result = await axios.get(`/euiqmenttypes?size=1000`);
      console.log("RES [getEquipmentType]:", result.data);
      dispatch(slice.actions.getEquipmentTypeSuccess(result.data));
    } catch (error) {
      console.log("ERR [getEquipmentType]:", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addEquipmentType(data, navigate) {
  return async () => {
    try {
      const result = await axios.post(`/euiqmenttypes`, data);
      console.log("RES [addEquipmentType] ======> ", result.data.data);
      dispatch(slice.actions.addEquipmentTypeSuccess(result.data.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [addEquipment] =======> ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editEquipmentType(id, data, navigate) {
  return async () => {
    try {
      const result = await axios.put(`/euiqmenttypes/${id}`, data);
      console.log("RES [editEquipmentType] =======> ", result?.data?.data);
      dispatch(slice.actions.editEquipmentTypeSuccess(result?.data?.data));
      navigate(navigateTo);
    } catch (error) {
      console.log("ERR [editEquipmentType] ", error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteEquipmentType(id = "") {
  return async () => {
    try {
      const result = await axios.delete(`/euiqmenttypes/${id}`);
      console.log("RES [deleteEquipment] =======> ", result);
      dispatch(getEquipmentType());
      dispatch(slice.actions.deleteEquipmentTypeSuccess(result.data.data));
    } catch (error) {
      dispatch(getEquipmentType());
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentPage(page) {
  return async () => {
    dispatch(slice.actions.setCurrentPage(page));
  };
}
